module.exports = __webpack_public_path__ + "static/media/trash.7689ed20.svg";